<div class="sliding-btn" [ngClass]="styleClass()">
  <div class="sliding-btn__inner">
    <div
      class="sliding-btn__indicator slidingDiv"
      [style.transform]="'translateX(' + active() * 100 + '%)'"
      [style.width]="'calc(100% / ' + normalizedTabs().length + ')'"
    >
      <div class="sliding-btn__indicator-fill"></div>
    </div>

    @for (item of normalizedTabs(); track $index) {
      <button
        class="sliding-tab"
        type="button"
        [class.sliding-tab--active]="active() === $index"
        [class.sliding-tab--inactive]="active() !== $index"
        (click)="changeActive($index)"
      >
        @if (item.icon) {
          <i [class]="item.icon + ' sliding-tab__icon'" aria-hidden="true"></i>
        }
        <span class="sliding-tab__label">{{ item.label | transloco }}</span>
      </button>
    }
  </div>
</div>

<ng-template
  *ngTemplateOutlet="content(); context: { $implicit: active() }"
></ng-template>
